module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationThailandThumb.d4031c8a.jpg";